import { cva } from 'class-variance-authority';

export const sidebarVariants = cva(
  [
    'fixed',
    'top-0',
    'right-0',
    'h-full',
    'w-80',
    'bg-white',
    'shadow-xl',
    'z-50',
    'transition-transform',
    'duration-300',
    'ease-in-out',
  ],
  {
    variants: {
      isOpen: {
        true: ['translate-x-0'],
        false: ['translate-x-full'],
      },
    },
    defaultVariants: {
      isOpen: false,
    },
  },
);
